import type { PropsWithChildren } from 'react';
import React, { useState } from 'react';
import { useLocation } from 'react-router';

import { getRoute } from 'src/shared/helpers/url';
import type {
  CurrentPage,
  SegmentHistoryContext,
} from 'src/shared/hooks/useSegmentHistory';
import {
  Provider as SegmentHistoryProvider,
  useSegmentHistory,
} from 'src/shared/hooks/useSegmentHistory';
import type { PageViewed } from 'src/shared/telemetry';

type Props = PropsWithChildren<{
  // See DS-846
  // eslint-disable-next-line react/no-unused-prop-types
  value?: Partial<SegmentHistoryContext>;
}>;

const SegmentHistory = ({ children }: Props) => {
  useSegmentHistory();

  // eslint-disable-next-line react/jsx-no-useless-fragment
  return <>{children}</>;
};

const Provider = ({ children, value, ...props }: Props) => {
  const { pathname } = useLocation();
  const [page, setPage] = useState<CurrentPage>(
    getRoute(pathname)?.page ?? null,
  );
  const [metadata, setMetadata] = useState<PageViewed>({});

  return (
    <SegmentHistoryProvider
      {...props}
      value={{ page, setPage, metadata, setMetadata, ...value }}
    >
      <SegmentHistory>{children}</SegmentHistory>
    </SegmentHistoryProvider>
  );
};

export { Provider };
